// extracted by mini-css-extract-plugin
export default {"tinyEditor":"editor_tinyEditor__a6hzA"};